import { encryptCryptoKeyWithAes, encryptCryptoKeyWithPublicKey, } from '@lucidlink/ts-crypto/crypto';
import { prepareMemberCommon, } from './prepare-member-common';
export const prepareOwnerMember = async ({ adminKeys, userKey, ...rest }) => {
    const { member, memberKeys } = await prepareMemberCommon(rest);
    const eAdminPrivateKeyByMemberKeyPromise = encryptCryptoKeyWithPublicKey(adminKeys.encryptPair.privateKey, memberKeys.encryptPair.publicKey);
    const ePrivateKeyByUserKeyPromise = encryptCryptoKeyWithAes(memberKeys.encryptPair.privateKey, userKey);
    return {
        ...member,
        eAdminPrivateKeyByMemberKey: await eAdminPrivateKeyByMemberKeyPromise,
        ePrivateKeyByUserKey: await ePrivateKeyByUserKeyPromise,
    };
};
